import React, { useState, useContext } from "react";
import {
  Dialog,
  DialogContent,
  Button,
  TextField,
  Rating,
  Box,
  Typography,
} from "@mui/material";
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { toast } from "react-hot-toast";
import axios from "axios";
import { UserContext } from "../../context/userContext/userContext";
import { useStyle } from "../../context/styleContext/styleContext";

const LeaveReviewModal = ({ isOpen, close, sku }) => {
  const { style } = useStyle();
  const { user, userEmail, userFirstName, userLastName } = useContext(UserContext);

  const [value, setValue] = useState(5);
  const [reviewComment, setReviewComment] = useState("");
  const [reviewUserName, setReviewUserName] = useState("Anonymous");
  const [reviewSent, setReviewSent] = useState(false);

  const closeFunction = () => {
    setReviewSent(false);
    setValue(5);
    setReviewUserName("Anonymous");
    setReviewComment("");
    close();
  };

  const submit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      const { data } = await axios.post("/create_review", {
        token,
        userName: reviewUserName,
        productSKU: sku,
        starRating: value,
        comment: reviewComment,
      });

      if (data.error) {
        toast.error(data.error);
      } else {
        toast.success("Thank you for your review!");
        setReviewSent(true);
      }
    } catch (error) {
      console.log(error);
      toast.error("An error occurred");
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={closeFunction}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        style: {
          backgroundColor: style.color1,
          borderRadius: 15,
          border: `1px solid ${style.color2}`,
        },
      }}
    >
      <DialogContent sx={{ padding: 3, color:style.color4 }}>
        {!reviewSent ? (
          <Box sx={{ textAlign: "center" }}>
            <Typography sx={{ mb: 2, fontSize:'2em', color:style.color4 }}>Your Rating</Typography>

            <Rating
              size="large"
              precision={0.5}
              value={value}
              onChange={(event, newValue) => setValue(newValue)}
              icon={<StarIcon sx={{ stroke: style.color8, strokeWidth: 1, fontSize: 40 }} />}
              emptyIcon={<StarBorderIcon sx={{ stroke: style.color8, fontSize: 40 }} />}
            />

            <Box sx={{ mt: 3 }}>
              <TextField
                label="Your Name"
                fullWidth
                variant="outlined"
                value={reviewUserName}
                onChange={(e) => setReviewUserName(e.target.value)}
                sx={{
                  mb: 3,
                  borderRadius:'5px',
                  backgroundColor: style.color4,
                  boxShadow:10,
                  input: { color: style.color1, fontSize: "14pt" },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: style.color1, borderWidth: 2 },
                    "&:hover fieldset": { borderColor: style.color1, borderWidth: 3 },
                    "&.Mui-focused fieldset": { borderColor: style.color1, borderWidth: 3 },
                  },
                  "& .MuiInputLabel-root": {
                    color: style.color3,
                    fontSize: "16pt",
                    "&.Mui-focused": { color: style.color3, fontStyle:'bold' },
                  },
                }}
              />

              <TextField
                label="Your Review"
                fullWidth
                multiline
                rows={5}
                variant="outlined"
                value={reviewComment}
                onChange={(e) => setReviewComment(e.target.value)}
                sx={{
                  mb: 3,
                  color:'black',
                  borderRadius:'5px',
                  boxShadow:10,
                  backgroundColor: style.color4,
                  input: { color: style.color1, fontSize: "14pt" },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: style.color1, borderWidth: 2 },
                    "&:hover fieldset": { borderColor: style.color2, borderWidth: 2 },
                    "&.Mui-focused fieldset": { borderColor: style.color1, borderWidth: 2 },
                  },
                  "& .MuiInputLabel-root": {
                    color:style.color3,
                    fontSize: "16pt",
                    "&.Mui-focused": { color: style.color3},
                  },
                }}
              />
            </Box>
            <Button size='small' onClick={submit} sx={{  color: style.color4, margin:'auto', filter: 'brightness(1.2)', display: 'block', boxShadow:10,backgroundColor: style.color1, fontSize: '12pt',  marginTop: '0px', borderColor: style.color2, borderWidth: '1px', width:'95%', maxWidth:'300px', borderStyle: 'solid', '&:hover': { backgroundColor: style.color2 } }}>Submit</Button>
            <Button size='small' onClick={closeFunction} sx={{color: style.color4, margin:'auto', filter: 'brightness(1.2)', display: 'block', boxShadow:10,backgroundColor: style.color1, fontSize: '12pt', borderColor: style.color2, borderWidth: '1px', width:'95%', maxWidth:'300px', marginTop:'15px', borderStyle: 'solid', '&:hover': { backgroundColor: style.color2 } }}>Go Back</Button>

          
          </Box>
        ) : (
          <Box sx={{ textAlign: "center", py: 5 }}>
            <Typography variant="h4" gutterBottom>
              Thank you!
            </Typography>
            <Button
              onClick={closeFunction}
              sx={{
                backgroundColor: style.color2,
                color: style.color4,
                borderColor: style.color1,
                borderWidth: 2,
                borderStyle: "solid",
                fontSize: "14pt",
                boxShadow:10,
                width: "100%",
                maxWidth: 300,
                "&:hover": { backgroundColor: style.color3 },
              }}
            >
              Go Back
            </Button>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default LeaveReviewModal;


// import {React, useState, useContext, useEffect} from "react";
// import ReactDOM from 'react-dom';
// import axios from 'axios';
// import { toast } from 'react-hot-toast';
// import{UserContext} from '../../context/userContext/userContext'
// import Button from '@mui/material/Button';
// import {useNavigate, Link} from 'react-router-dom';
// import { Checkbox, TextField, FormGroup, FormControlLabel } from "@mui/material";
// import Rating from '@mui/material/Rating';
// import { useStyle } from "../../context/styleContext/styleContext";
// import Box from '@mui/material/Box';
// import StarIcon from '@mui/icons-material/Star';
// import StarBorderIcon from '@mui/icons-material/StarBorder';



// const LeaveReviewModal = ({ isOpen, close, sku, children }) => {

//     const { style, setStyle } = useStyle();
//     const navigate = useNavigate()
//     const { user, userEmail, userFirstName, userLastName } = useContext(UserContext);
//     const [checkBoxChecked, setCheckBoxChecked] = useState(false)
//     const [value, setValue] = useState(5);
//     const [reviewComment, setReviewComment] = useState("");
//     const [reviewUserName, setReviewUserName] = useState("Anonymous");
//     const [reviewSent, setReviewSent] = useState(false)
    
  
//     if (!isOpen) return null;

//     const closeFunction = async (e) => { 
                         
//                 setReviewSent(false)
//                 setValue(5)
//                 setReviewUserName("Anonymous")
//                 setReviewComment("")
//                 close() 

//     }



//     const submit = async (e) => {

//         e.preventDefault();
//         console.log("submit...")
        
        
//         var okToSend = true;


//         //var token = "";

//         var token = localStorage.getItem('token')
        


//         const productSKU = sku
//         const userName = reviewUserName
        

//         console.log("sku:", productSKU)
        
//         const starRating = value
//         const comment = reviewComment
       


//         if(okToSend)
//         {
//             console.log("sending....")
//             try{
//                 okToSend = false   
//                 const{data} = await axios.post('/create_review',{token, userName, productSKU, starRating, comment})
                    
    
//             if(data.error){
//                 console.log("error")
//                 toast.error(data.error)
//             }
//             else{
//                 //setData({})
//                 toast.success('Thank you for your review!')
//                 setReviewSent(true)
//                 //navigate('/home')
//             }
//             }catch(error){
//                 console.log(error)
//             }
//         }
//     }



        

//   return ReactDOM.createPortal(


    
//     <div style={modalStyle}>
//       <div style={{padding: '0px',
//             borderRadius: '15px',
//             maxWidth: '800px',
//             minHeight: '300px',
//             margin: 'auto',
//             display: 'flex',
//             flexDirection: 'column',
//             width: '95%',
//             borderColor:style.color1,
//             borderWidth:'2px',
//             borderStyle:'solid',
//             backgroundColor: style.color4,}}>
//         <div style={{width:'100%', margin:'auto', marginTop:'0px'}}>
            

//                   {!reviewSent && (

//                     <div style={{display:'flex', flex:1, flexDirection:'column', textAlign:'center', width:'100%', margin:'auto'}}>
                        
//                         <>
//                         <div style={{marginBottom:'5px', marginTop:'0px'}}>
//                           <h1 style={{ fontSize:'1.6em'}}>
//                             Your Rating:
//                           </h1>
                          
//                           </div>
//                           <div style={{marginBottom:'15px'}}><Rating name="simple-controlled" size={'large'} precision={0.5} value={value} onChange={(event, newValue) => {setValue(newValue);}} icon={<StarIcon sx={{ stroke: style.color8, strokeWidth: 1, width:'40px', height:'40px' }} />}
//                                                                                emptyIcon={<StarBorderIcon sx={{ stroke: style.color8, width:'40px', height:'40px'}} />}/></div>

//                           <Box
//                               component="form"
//                               sx={{ '& .MuiTextField-root': { m: 1, width: '95%', maxWidth:'1000px' } }}
//                               noValidate
//                               autoComplete="off"
//                               >
//                                 <div style={{ width:'95%', margin:'auto'}}>

//                                 <TextField
//                                   id="standard-multiline-static"
//                                   label="Your Name:"
//                                   value={reviewUserName}
//                                   onChange={(e) => setReviewUserName(e.target.value)}
                              
//                                   variant="outlined"

                                          
//                                           sx={{
//                                               width:'95%',                                                
//                                               backgroundColor: style.color10,
//                                               borderRadius:'4px',

//                                               marginBottom:'25px',
//                                               '& .MuiInputBase-input': {
//                                               color: style.color1,  // Change the font color here
//                                               fontSize: '14pt',  // Change the font size here
                                                                              
//                                               },
//                                               '& .MuiOutlinedInput-root': {
//                                               '& fieldset': {
//                                                   borderColor: style.color1, // Change the border color if needed
//                                                   borderWidth:'2px',
//                                                   borderStyle:'solid'
//                                               },
//                                               '&:hover fieldset': {
//                                                   borderColor: style.color1, // Change the border color on hover if needed\
//                                                   borderWidth:'3px',                                                               
                                          
                                                  
//                                               },
//                                               '&.Mui-focused fieldset': {
//                                                   borderColor: style.color1, // Change the border color when focused if needed
//                                                   borderWidth:'3px'
                                                  
//                                               },
//                                               '&.Mui-disabled': {
//                                                   '& fieldset': {
//                                                   borderColor: style.color1, // Change the border color when disabled
//                                                   },
//                                               },
//                                               },
//                                               '& .MuiInputLabel-root': {
//                                               color: style.color1, // Change the label color here
//                                               fontSize:'16pt',
//                                               },
//                                               '& .MuiInputLabel-root.Mui-focused': {
//                                               color: style.color1, // Change the label color when focused here                                 
//                                               },
//                                               '& .MuiInputLabel-root.Mui-disabled': {
//                                               color: style.color1, // Change the label color when disabled
//                                               },
//                                               '& .MuiInputBase-root.Mui-disabled': {
//                                               '& input': {
//                                                   color: style.color1, // Change the input font color when disabled // so it works in safari
//                                                   WebkitTextFillColor: style.color1, // so it works on chrome
//                                                   fontSize:'16pt'
//                                               },
//                                               },
//                                               '& .MuiOutlinedInput-input': { color: style.color1,
//                                               '&:-webkit-autofill': { WebkitBoxShadow: '0 0 0 100px #312E33 inset',
//                                                   WebkitTextFillColor: style.color4, color:style.color1
//                                               }, }, 
//                                           }}
//                                           />


//                                 </div>
//                               <div style={{ width:'95%', margin:'auto'}}>

//                                   <TextField
//                                   id="standard-multiline-static"
//                                   label="Your Review:"
//                                   value={reviewComment}
//                                   onChange={(e) => setReviewComment(e.target.value)}
//                                   multiline
//                                   rows={5}                                    
//                                   variant="outlined"

                                          
//                                           sx={{
//                                               width:'90%',

//                                               backgroundColor: style.color10,
//                                               borderRadius:'4px',
//                                               marginBottom:'25px',
//                                               '& .MuiInputBase-input': {
//                                               color: style.color1,  // Change the font color here
//                                               fontSize: '14pt',  // Change the font size here
                                                                              
//                                               },
//                                               '& .MuiOutlinedInput-root': {
//                                               '& fieldset': {
//                                                   borderColor: style.color1, // Change the border color if needed
//                                                   borderWidth:'2px',
//                                                   borderStyle:'solid'
//                                               },
//                                               '&:hover fieldset': {
//                                                   borderColor: style.color1, // Change the border color on hover if needed\
//                                                   borderWidth:'3px',                                                               
                                          
                                                  
//                                               },
//                                               '&.Mui-focused fieldset': {
//                                                   borderColor: style.color1, // Change the border color when focused if needed
//                                                   borderWidth:'3px'
                                                  
//                                               },
//                                               '&.Mui-disabled': {
//                                                   '& fieldset': {
//                                                   borderColor: style.color1, // Change the border color when disabled
//                                                   },
//                                               },
//                                               },
//                                               '& .MuiInputLabel-root': {
//                                               color: style.color2, // Change the label color here
//                                               fontSize:'16pt',
//                                               },
//                                               '& .MuiInputLabel-root.Mui-focused': {
//                                               color: style.color2, // Change the label color when focused here                                 
//                                               },
//                                               '& .MuiInputLabel-root.Mui-disabled': {
//                                               color: style.color2, // Change the label color when disabled
//                                               },
//                                               '& .MuiInputBase-root.Mui-disabled': {
//                                               '& input': {
//                                                   color: style.color2, // Change the input font color when disabled // so it works in safari
//                                                   WebkitTextFillColor: style.color2, // so it works on chrome
//                                                   fontSize:'16pt'
//                                               },
//                                               },
//                                               '& .MuiOutlinedInput-input': { color: style.color1,
//                                               '&:-webkit-autofill': { WebkitBoxShadow: '0 0 0 100px rgb(221, 230, 237) inset',
//                                                   WebkitTextFillColor: style.color4, color:style.color1
//                                               }, }, 
//                                           }}
//                                           />
//                               </div>
//                               </Box>


                          
//                           <div style={{ marginTop:'35px'}}>
//                           <Button onClick={submit} sx={{ my: 2, color:style.color4, display:'block', backgroundColor:style.color2, fontSize:'14pt', width:'100%', minWidth:'250px', maxWidth:'300px', margin:'auto', marginTop:'0px', borderColor:style.color1, borderWidth:'2px', borderStyle:'solid', '&:hover': {backgroundColor: style.color3 }, }}>Submit</Button>
//                           </div>
//                           <div style={{ marginTop:'10px', marginBottom:'25px'}}>
//                           <Button onClick={closeFunction} sx={{ my: 2, color:style.color4, display:'block', backgroundColor:style.color2, fontSize:'14pt', width:'100%', minWidth:'250px', maxWidth:'300px', margin:'auto', marginTop:'0px', borderColor:style.color1, borderWidth:'2px', borderStyle:'solid', '&:hover': {backgroundColor: style.color3 }, }}>Go Back</Button>
//                           </div>

//                             </>
                          

//                   </div>

//                   )}

//                   {reviewSent && (
//                     <>
//                     <div style={{margin:'auto', textAlign:'center',  marginTop:'50px', marginBottom:'100px'}}><h1>
//                       Thank you!
//                       </h1></div>
//                       <div>
//                         <Button onClick={closeFunction} sx={{ my: 2, color:style.color4, display:'block', backgroundColor:style.color2, fontSize:'14pt', width:'100%', minWidth:'250px', maxWidth:'300px', margin:'auto', marginTop:'0px', borderColor:style.color1, borderWidth:'2px', borderStyle:'solid', '&:hover': {backgroundColor: style.color3 }, }}>Go Back</Button>
//                       </div>
//                     </>

                    
//                   )}

                    
           
            
//         </div>
//       </div>

//     </div>,
//     document.getElementById('modal-root')
//   );
// };

// const modalStyle = {

    
//   position: 'fixed',
//   top: 0,
//   left: 0,
//   right: 0,
//   bottom: 0,
//   backgroundColor: 'rgba(0, 0, 0, 0.75)',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   maxHeight: '100vh',
//   overflowY: 'auto',
//   margin:'auto',
//   zIndex: "1000",
// };


// const buttonStyle = {
//   marginTop: '20px',
//   alignSelf: 'center'
// };

// export default LeaveReviewModal;
